import React from 'react';

import { Button, Grid, makeStyles, Typography } from '@material-ui/core';

import { DCM } from '../../models/Resource';

const useStyles = makeStyles((theme) => {
  return {
    stats: {
      width: 'calc(50% - 8px)',
    },
    statsContainer: {
      background: '#F5F5F5',
      borderRadius: '10px',
      fontSize: '11px',
      gap: '16px',
      lineBreak: 'anywhere',
      padding: '7px 14px',
      textAlign: 'left',
    },
    statsText: {
      fontSize: '11px',
      fontWeight: 'bold',
      lineBreak: 'anywhere',
    },
    typographyChangeTitle: {
      color: theme.palette.primary.main,
      cursor: 'pointer',
      fontSize: '11px',
    },
    typographyImagingStudy: {
      fontSize: '12px',
      fontWeight: '600',
      marginBottom: '4px',
    },
    typographyRemove: {
      color: '#B12A2A',
      cursor: 'pointer',
      fontSize: '11px',
    },
    uploadActions: {
      marginTop: '4px',
    },
  };
});

export default ({ fileStatus, hideFileControls, onChangeTitle, onRemoveFiles, onFileChange, shouldSelectAnyStudy, onOpenImageSelectionDialog }) => {
  const classes = useStyles();

  const handleFileChange = (e) => {
    if (onFileChange) onFileChange(e);
  };

  const handleOpenImageSelectionDialog = () => {
    if (onOpenImageSelectionDialog) onOpenImageSelectionDialog();
  };

  if (fileStatus.uploaded) {
    return (
      <div style={{ width: '100%' }} className="">
        <Typography className={`text-left ${classes.typographyImagingStudy}`}>
          Files <span style={{ color: '#B12A2A' }}>*</span>
        </Typography>
        <Grid container className={classes.statsContainer}>
          <Grid item className={classes.stats}>
            <Typography className={classes.statsText}>Title</Typography>
            <Typography className={classes.statsText}> {fileStatus.study} </Typography>
          </Grid>
          <Grid item className={classes.stats}>
            <Typography className={classes.statsText}>{fileStatus.fileType === DCM ? 'Images' : 'File Type'}</Typography>
            <Typography className={classes.statsText} style={{ color: fileStatus.imageCount > 0 ? '#388E3C' : 'B12A2A' }}>
              {fileStatus.fileType === DCM ? `${fileStatus.imageCount} Images` : fileStatus.fileType.toUpperCase()}
            </Typography>
          </Grid>
        </Grid>
        {!hideFileControls && (
          <div className={classes.uploadActions}>
            <span aria-hidden="true" onClick={onChangeTitle}>
              <span className={classes.typographyChangeTitle}>Change Title</span>
            </span>
            &nbsp; | &nbsp;
            <span className={classes.typographyRemove} onClick={onRemoveFiles} aria-hidden="true">
              Remove
            </span>
          </div>
        )}
      </div>
    );
  }

  return (
    <>
      {!shouldSelectAnyStudy ? (
        <>
          <input onChange={handleFileChange} multiple directory="" webkitdirectory="" moxdirectory="" hidden id="raised-button-study" type="file" />
          <label htmlFor="raised-button-study">
            <Button variant="outlined" fullWidth component="span" className={classes.uploadRadiologyImages} color="primary">
              Upload Radiology Images
            </Button>
          </label>
        </>
      ) : null}

      {shouldSelectAnyStudy ? (
        <Button onClick={handleOpenImageSelectionDialog} variant="outlined" fullWidth component="span" className={classes.uploadRadiologyImages} color="primary">
          Upload Radiology Images
        </Button>
      ) : null}
    </>
  );
};
